import { css, keyframes } from 'goober';
import { isEmpty, isNumber, noop } from 'mc-ui-utils';
import React, { useCallback, useEffect, } from 'react';
import constants from '../../constants';
import State from '../../state';
import colors from '../../styles/colors';
import font from '../../styles/font';
import { transparentize } from '../../styles/mixins';
import { getViewPortDimensions } from '../../utils/common';
import { openSettings } from '../../utils/khazaddumbridge';
import Navigator from '../Glance/Navigator';
const { vh } = getViewPortDimensions();
const fadeIn = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const Container = css `
  position: absolute;
  background-color: ${colors.glanceBlack};
  background-image: linear-gradient(
    to bottom,
    ${transparentize(0, colors.pickledBluewood)},
    ${transparentize(1, colors.pickledBluewood)}
  );
  width: 100%;
  top: 0;
  left: 0;
  min-height: 100vh;
  height: ${vh};
  overflow: hidden;
  flex-direction: column;
  color: ${colors.white};
  will-change: transform, opacity;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate3d(0%, 0, -1px);
  &.current {
    transform: translate3d(0%, 0, 1px);
    transition: transform ${constants.TRANSITION_DURATION};
  }
  &.next {
    transform: translate3d(0%, 0, 0px);
    transition: transform ${constants.TRANSITION_DURATION};
    animation: ${fadeIn} 0.5s ease-in-out forwards;
  }
  &.prev2,
  &.prev {
    transform: translate3d(-100%, 0, 2px);
  }
  &.prev {
    transition: transform ${constants.TRANSITION_DURATION};
  }
`;
const Title = css `
  font-size: ${font.fontXLarge};
  font-weight: ${font.fontWtSemiBold};
  margin: 0 0 20px;
`;
const Subtitle = css `
  font-size: ${font.fontBase};
  font-weight: ${font.fontWtNormal};
  margin: 0 0 30px;
`;
const Button = css `
  background: ${transparentize(0.9, colors.white)};
  color: ${colors.white};
  font-size: ${font.fontBase};
  line-height: 19.5px;
  width: 172px;
  height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 0;
  border-radius: 55px;
  position: relative;
`;
const LastScreen = ({ isActive, isNext, isPrev, isPrev2, index, setIndex, hasMore = true, }) => {
    let className = '';
    if (isActive) {
        className = 'current';
    }
    if (isNext) {
        className = 'next';
    }
    if (isPrev) {
        className = 'prev';
    }
    if (isPrev2) {
        className = 'prev2';
    }
    useEffect(() => {
        let timer;
        if (!isEmpty(index) && isActive) {
            timer = window.setTimeout(() => {
                setIndex(index + 1);
            }, constants.STORY_PLAYER_DURATION);
        }
        return () => {
            if (!isEmpty(timer)) {
                clearTimeout(timer);
            }
        };
    }, [index, setIndex, isActive]);
    const onNavigate = useCallback((e) => {
        const step = parseInt(e.target.dataset.step, 10);
        if (index + step < State.totalGlances - 1) {
            setIndex(index + step);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [index]);
    return (React.createElement("section", { className: `${Container} ${className}` },
        React.createElement("p", { className: Title }, "You are all caught up"),
        hasMore && React.createElement("p", { className: Subtitle }, "Tap to continue"),
        isNumber(index) && (React.createElement(Navigator, { index: index, onNavigate: onNavigate, onHoldGlance: noop, onUnHoldGlance: noop })),
        State.isSdk && (React.createElement("button", { className: Button, onClick: openSettings }, "Update Preferences"))));
};
export default LastScreen;
//# sourceMappingURL=index.js.map